import { Component, OnInit, Input, ViewChild, ChangeDetectorRef, EventEmitter, Output, TemplateRef, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { ProductService } from 'src/app/services/product.service';
import { download, getPageSize, ResourceAccess, validateAllFormFields } from 'src/app/shared/utils/calsoft-validators';
import { ListColumn } from 'src/app/shared/list/list-column.model';
import { ROUTE_TRANSITION } from 'src/app/app.animation';
import { CommonService } from 'src/app/services/common.service';
import { AttributeService } from 'src/app/services/attribute.service';
import { AttributesetService } from 'src/app/services/attributeset.service';
import { ImportExcelComponent } from '../../commonImport/import-excel/import-excel.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { constant } from 'lodash';
import Integer from '@zxing/library/esm/core/util/Integer';
import { environment } from 'src/environments/environment';
import { FormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { O } from '@angular/cdk/keycodes';
import { RestrictionComponent } from 'src/app/shared/restriction-pop-up/restriction/restriction.component';
import { CommonDownloadComponent } from '../../common-download/common-download.component';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { LoaderService } from 'src/app/services/loader.service';
import { CrmBusinessEditComponent } from 'src/app/shared/crm-business-edit/crm-business-edit.component';

@Component({
  selector: 'calsoft-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' }

})
export class ProductComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';
  isGridVisible: boolean = true;
  rowLeft: string = "100";
  rowRight: string = "0";
  rowgap: string = "0px";


  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  productList: any;
  private dateFormat = Constant.dateFormat;
  paginationDetail = new BehaviorSubject(
    {
      length: 10,
      pageIndex: 0,
      pageSize: 10
    });
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  filterActive: boolean = false;
  sortParam: any = 'entityId' + "," + Constant.Dsc;
  pageIndex: any;
  pageSize: number;
  pageList: any;
  spinner: boolean;
  search: any;
  pageSizeValue: any;
  resourcePrivilege: any;
  elements: any
  setList: any = [];
  read: any = false;
  serverPath: any = environment.ImageAPI;
  downloadDataComplete: string;
  create: any;
  productLimitedRestrictionValue: any;
  productLimitedRestriction: boolean = false;
  configurableProductDropdown: any;
  configattributeType: any;
  productSelected: any;
  configData: any;
  GridType: any;
  filterType: any = 1;
  currentRouterPath: string;

  constructor(
    private productService: ProductService,
    private ecryptService: EcryptServiceService,
    private router: Router,
    private commonService: CommonService,
    private attributesetService: AttributesetService,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private _formBuilder: FormBuilder,
    private loaderService: LoaderService,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    this.currentRouterPath = this.router.url;
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }
  cid: string;

  ngOnInit() {
    this.isMobile = window.innerWidth <= 768;
    if (!this.isMobile) {
      this.isGridVisible = true;
    }

    this.checkScreen();

    const encryptedConfig = localStorage.getItem('configSettingsData')

    if (encryptedConfig) {

      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedConfig);
        this.configData = JSON.parse(decrypted);
        this.GridType = this.configData.gridType;
        this.filterType = this.configData.filterType;

      } catch (err) {
        console.error("Error decrypting crmSettingsData", err);
      }
    }

    this.textAccount = 'OK';
    this.downloadDataComplete = 'OK';
    this.getResource();
    let values = localStorage.getItem(Constant.enterPriseKey);

    if (values != null) {

      this.cid = "&cid=" + values
    }

  }
  bulkUpload: boolean = false;
  _form: UntypedFormGroup;


  getResource() {
    this.commonService
      .getAllAccessForResource(ResourceAccess.PRODUCT)
      .subscribe((data: any) => {

        if (!data.read) {
          this.router.navigate(['/unauthorized']);
        } else {
          if (data.restriction.length > 0) {
            this.bulkUpload = data.restriction[0].bulkUpload == 1 ? true : false;
            this.productLimitedRestrictionValue = data.restriction[0].productLimitedRestriction;
            this.productLimitedRestriction = true;
          } else {
            this.productLimitedRestriction = false;
          }


          this.resourcePrivilege = data;
          this.read = data.read;
          this.getProduct();
        }
      });
  }



  getProduct() {

    this.firstFormGroup.value.page = this.page;
    this.firstFormGroup.value.size = this.size;

    if (this.sortParam.split(",")[0] == 'entityId') {
      this.firstFormGroup.value.sort = 'name';
    } else {
      this.firstFormGroup.value.sort = this.sortParam.split(",")[0]
    }
    this.firstFormGroup.value.sortBy = this.sortParam.split(",")[1]
    this.firstFormGroup.patchValue(this.firstFormGroup.value)
    this.filterActive = false;
    this.spinner = true;
    this.productService.getProducts(this.page, this.size, this.sortParam).subscribe(
      res => {
        this.spinner = false;
        this.productList = new MatTableDataSource();
        this.elements = res['numberOfElements'];
        this.productList = res['content'];
        this.productList.sort = this.sort;
        this.pageList = res['totalElements'];
        this.productList.paginator = this.paginator;
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
        this.spinner = false;
      }
    )
  }

  getUpdate(event) {
    this.paginationDetail.next(event);
    this.page = event.pageIndex;
    this.size = event.pageSize;
    this.DetectingRequestType();
  }

  sortData(event) {
    if (event.active != 'categoryNames' && event.active != 'select' && event.active != 'actions') {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      this.sortParam = event.active;
      if (event.direction == 'asc') {
        this.sortParam = this.sortParam + "," + Constant.Asc;
      } else if (event.direction == 'desc') {
        this.sortParam = this.sortParam + "," + Constant.Dsc;
      }
      this.DetectingRequestType();
    }

  }

  DetectingRequestType() {
    if (!this.filterActive) {
      this.getProduct();
    }
    else {
      this.filterOption(this.search);
    }
  }

  filterOption(event) {
    this.filterActive = true;
    this.search = event;
    this.spinner = true;
    this.productService.getProductBySearch(this.search, this.page, this.size, this.sortParam).subscribe(
      res => {
        this.spinner = false;
        this.productList = res['content'];
        this.elements = res['numberOfElements'];
        this.pageList = res['totalElements'];
        this.pageSizeValue = getPageSize(this.pageList);
      },
      error => {
        this.spinner = false;
      })

  }

  @Input()
  columns: ListColumn[] = [
    { name: 'select', property: 'select', visible: true, isModelProperty: false },
    { name: 'Image', property: 'image', visible: true, isModelProperty: false },
    { name: 'Product Id', property: 'productIncrementId', visible: true, isModelProperty: true },
    { name: 'Name', property: 'name', visible: true, isModelProperty: false },
    { name: 'Type', property: 'type', visible: true, isModelProperty: true },
    { name: 'ATTRIBUTE SET NAME', property: 'attributeSetName', visible: true, isModelProperty: true },
    { name: 'sku', property: 'sku', visible: true, isModelProperty: true },
    { name: 'Quantity', property: 'qty', visible: true, isModelProperty: true },
    { name: 'Status', property: 'isInStock', visible: true },
    { name: 'Category', property: 'categoryNames', visible: true, isModelProperty: false },
    { name: 'created Date', property: 'createdDate', visible: false, isModelProperty: false },
    { name: 'updated Date', property: 'updatedDate', visible: false, isModelProperty: false },
    { name: 'Action', property: 'actions', visible: true, disabled: true },
  ] as ListColumn[];



  filterSelectObj = [
    {
      name: 'Select',
      property: 'name',
      type: 'disable',
      position: 'twonth1Value',
      options: []
    },
    {
      name: 'Image',
      property: 'name',
      type: 'disable',
      position: 'twonthValue',
      options: []
    },

    {
      name: 'Product ID',
      property: 'productIncrementId',
      type: 'text',
      position: 'firstValue',
      options: []
    },
    {
      name: 'Name',
      property: 'name',
      type: 'text',
      position: 'secondValue',
      options: []
    },

    {
      name: 'Type',
      property: 'type',
      type: 'select',
      position: 'thirdValue',
      options: [
        { value: 'simple', viewValue: 'simple' },
        { value: 'Configurable', viewValue: 'Configurable' },
        { value: 'Variants', viewValue: 'Variants' },
        { value: 'Booking', viewValue: 'Booking' },
        { value: 'Subscription', viewValue: 'Subscription' },
        { value: 'Course', viewValue: 'Course' },
        { value: 'Variants Subscription', viewValue: 'Variants Subscription' },
      ]
    },
    {
      name: 'ATTRIBUTE SET NAME',
      property: 'attributeSetName',
      type: 'text',
      position: 'fourthValue',
      options: [],
    },
    {
      name: 'Sku',
      property: 'sku',
      type: 'text',
      position: 'fifthValue',
      options: []
    },
    {
      name: 'Quantity',
      property: 'qty$n',
      type: 'price',
      position: 'sixthValue',
      options: []
    },
    {
      name: 'STATUS',
      property: 'isInStock',
      type: 'select',
      position: 'seventhValue',
      options: [
        { value: 1, viewValue: 'Yes' },
        { value: 0, viewValue: 'No' },
      ]
    },
    {
      name: 'Category',
      property: 'categoryNames_txt',
      type: 'text',
      position: 'eightValue',
      options: []
    },
    {
      name: 'created Date',
      property: 'createdDate',
      type: 'date',
      position: 'ninthValue',
      options: []
    },

    {
      name: 'updated Date',
      property: 'updatedDate',
      type: 'date',
      position: 'tenthValue',
      options: []
    },




  ]



  filterSelectObjDub = [
    {
      name: 'Name',
      property: 'name',
      type: 'text',
      position: 'firstValue',
      options: []
    },

    {
      name: 'Type',
      property: 'type',
      type: 'select',
      position: 'secondValue',
      options: [
        { value: 'simple', viewValue: 'simple' },
        { value: 'Configurable', viewValue: 'Configurable' },
        { value: 'Variants', viewValue: 'Variants' },
        // { value: 'Grouped Product', viewValue: 'Grouped Product' },
        // { value: 'Virtual Product', viewValue: 'Virtual Product' },
        // { value: 'Bundle Product', viewValue: 'Bundle Product' },
        // { value: 'Downloadable Product', viewValue: 'Downloadable Product' },
      ]
    },
    {
      name: 'ATTRIBUTE SET NAME',
      property: 'attributeSetName',
      type: 'text',
      position: 'thirdValue',
      options: [],
    },
    {
      name: 'Sku',
      property: 'sku',
      type: 'text',
      position: 'fourthValue',
      options: []
    },
    {
      name: 'Quantity',
      property: 'qty',
      type: 'price',
      position: 'fifthValue',
      options: []
    },
    {
      name: 'STATUS',
      property: 'isInStock',
      type: 'select',
      position: 'sixthValue',
      options: [
        { value: 1, viewValue: 'Yes' },
        { value: 0, viewValue: 'No' },
      ]
    },

  ]

  applyFilter(filterValue: string) {
    this.productList.filter = filterValue.trim().toLowerCase();
  }

  addproduct() {
    let productId = 0;

    let plan = localStorage.getItem("plan");

    if (plan != undefined) {

      if (parseInt(plan) == 5) {

        const encryptedData = localStorage.getItem('configSettingsData');
        if (encryptedData) {
          try {
            const decrypted = this.ecryptService.decryptionAES(encryptedData);
            const data = JSON.parse(decrypted);

            if (data != null) {

              if (data['defaultProductSet'] > 0) {
                this.router.navigate([`product/add-edit-product/${productId}/${data['defaultProductSet']}`])

              } else {
                this.router.navigate([`product/addproduct/${productId}`])
              }
            }

          } catch (error) {
            console.error("Failed to decrypt crmSettingsData:", error);
          }
        } else {
          this.router.navigate([`product/addproduct/${productId}`])
        }

      } else {



        this.router.navigate([`product/addproduct/${productId}`])
      }

    }



  }



  onFilterChange(value) {
    if (value == '') {
      this.getProduct();
      this.search = '';
    }
    else {
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;

      let val: any | null = null;

      const encryptedUserSettings = localStorage.getItem('userSettingsData');

      if (encryptedUserSettings) {
        try {
          const decrypted = this.ecryptService.decryptionAES(encryptedUserSettings);
          const userSettings = JSON.parse(decrypted);
          val = userSettings.userType;
        } catch (error) {
          console.error('Error decrypting or parsing userSettingsData:', error);
        }
      }

      if (!val) {
        const encryptedSigninDetails = localStorage.getItem('signinDetails');
        if (encryptedSigninDetails) {
          try {
            const decrypted = this.ecryptService.decryptionAES(encryptedSigninDetails);
            const signinDetails = JSON.parse(decrypted);
            val = signinDetails.userType;
          } catch (error) {
            console.error('Error decrypting or parsing signinDetails:', error);
          }
        }
      }

      if (val > 0) {
        let searchTerm = "name:" + '*' + value.trim() + '*'
          + "' AND supplierId_cust:" + '*' + val + '*'
          + "' OR sku:" + '*' + value.trim() + '*' + "' "
        this.filterOption(searchTerm)
      } else {
        let searchTerm = "name:" + '*' + value.trim() + '*'
          + "' OR sku:" + '*' + value.trim() + '*' + "' "
        this.filterOption(searchTerm)
      }

    }
  }

  onFilterChangeColumn(i) {
    if (i == undefined) {
      this.filterActive = false
      this.getProduct();
    } else {
      i = i.replace(/'/g, '');
      this.page = Constant.PAGE;
      this.size = Constant.SIZE;
      let val: any;
      const encryptedUserSettings = localStorage.getItem('userSettingsData');

      if (encryptedUserSettings) {
        const decrypted = this.ecryptService.decryptionAES(encryptedUserSettings);
        const userSettings = JSON.parse(decrypted);
        val = userSettings.userType;
      }
      if (val > 0) {
        //   let searchTerm = "name:" + '*' + value.trim() + '*'
        //   + "' AND supplierId_cust:" + '*' + val + '*'
        //   + "' OR sku:" + '*' + value.trim() + '*' + "' "
        // this.filterOption(searchTerm)

        //  let length=i.length;

        //  i = i.substring(0, length - 1);

        i = i + " AND supplierId_cust:" + '*' + val + '*' + "'"
        this.filterOption(i)
      } else {
        this.filterOption(i);
      }

    }
    this.loaderService.hide();
  }

  exportExcel() {
    this.router.navigate([`/product/export-product`])
  }

  importExcel() {
    this.router.navigate([`/product/import-product`])
  }

  ImportImageImport() {
    this.router.navigate([`/product/image-import`])
  }


  downloadReportTemplate() {
    this.productService.downloadProductTemplate().subscribe(
      data => {
        download(data);
      },
    )
  }

  downloadTemplate1() {
    this.productService.downloadProductNameTemplate().subscribe(
      data => {
        download(data);
      },
    )
  }

  exportGmc() {
    this.productService.downloadGmc().subscribe(
      data => {
        download(data);
      },
    )
  }

  sitedata() {
    this.productService.downloadshopdata().subscribe(
      data => {
        download(data);
      }
    )
  }

  openImportDataPopup() {
    let dialogRef = this.dialog.open(ImportExcelComponent, {
      disableClose: true,
      width: '900px',
      data: { url: 'excelImportProductQtyAndPrice' }
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(result => {
      if (result['event'] != 'close') {
        this.getProduct();
      }
    });
  }


  openImportDataPopup1() {
    let dialogRef = this.dialog.open(ImportExcelComponent, {
      disableClose: true,
      width: '900px',
      data: { url: 'excelImportProductNameAndDescription' }
    });
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe(result => {
      if (result['event'] != 'close') {
        this.getProduct();
      }
    });
  }

  @ViewChild('delete') delete: TemplateRef<any>;

  deleteAllProductDialog() {
    this.textAccount = "OK";
    let dialogRef = this.dialog.open(this.delete, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  deleteAllProduct() {
    if (this.resourcePrivilege?.delete) {
      this.spinner = true;
      this.textAccount = "Processing";
      this.productService.deleteById().subscribe(
        response => {
          this.spinner = false;
          this.textAccount = "OK";
          this.dialog.closeAll();
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            this.getProduct();
          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        error => {
          this.textAccount = "OK";
          this.spinner = false;
          this.dialog.closeAll();
        }
      );
    }
  }

  @ViewChild('delete1') delete1: TemplateRef<any>;

  deleteIndividualDialog() {
    let dialogRef = this.dialog.open(this.delete1, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  deleteAllProductId(id: any) {
    this.spinner = true;
    this.textAccount = "Processing";
    this.productService.deleteByProductId(id).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getProduct()
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      error => {
        this.textAccount = "OK";
        this.spinner = false;
      })

  }

  editProduct(productId, setId, type) {

    if (type == 'simple') {
      this.router.navigate([`product/editproduct/${productId}/${setId}`])
    }
    else if (type == 'Simple') {
      this.router.navigate([`product/editproduct/${productId}/${setId}`])
    } else if (type == 'Variants') {
      this.router.navigate([`product/add-edit-product/variant/${productId}/${setId}`])
    }
    else if (type == 'Booking') {
      this.router.navigate([`product/add-edit-product/booking/${productId}/${setId}`])
    }
    else if (type == 'Course') {
      this.router.navigate([`product/add-edit-product/course/${productId}/${setId}`])
    }
    else if (type == 'Variants Subscription') {
      this.router.navigate([`product/add-edit-product/variantSubscription/${productId}/${setId}`])
    }
    else {
      this.router.navigate([`product/editproduct/config/${productId}/${setId}`])
    }

  }
  public serverPath4 = environment.commonImageApiNew
  public serverPath7 = environment.commonImageApi + "catalog/product";
  public serverPath8 = environment.commonImageApi;
  /** Base URL for bulk-imported images stored as /productId/filename.jpg under commonimages */
  public serverPathBulk = environment.commonImageApi + 'catalog/product/commonimages';

  getImage(value, images, row) {

    if (row.maintainImageIndConfProduct == 1 && row.type == 'Variants') {



      let i = 0
      let key = '';

      this.configurableProductDropdown = row['configProduct'];

      if (this.configurableProductDropdown != null) {
        for (let key of Object.keys(this.configurableProductDropdown)) {
          if (i == 0) {
            key = key;
            this.productSelected = JSON.parse(this.configurableProductDropdown[key]);

            break;
          }

        }


        // let productSelected = JSON.parse(this.configurableProductDropdown[key]);



        value = this.productSelected['productImageUrl']
        images = this.productSelected['images']
      }
      if (value == '') {
        if (images != null) {

          if (images.length > 0) {
            value = images[0]
          }



        }
      }


    }

    if (value != null) {

      if (value.includes('external')) {
        return this.serverPath8 + value;
      }
      if (value.includes('commonimages')) {
        return this.serverPath7 + value;
      }
      else if (value.includes('http')) {
        return value;
      } else if (/^\/\d+\//.test(value)) {
        // Bulk-imported images stored as /productId/filename.jpg under catalog/product/commonimages
        return this.serverPathBulk + value;
      } else if (!value.includes('medicineimages')
        && !value.includes('http')) {

        return this.serverPath + '/' + value + this.cid;
      } else if (!value.includes('medicineimages')) {
        return this.serverPath4 + value;
      } else {
        return "assets/images/logo/no-image.png";
      }

    }
  }





  //seleted data

  selectionProduct: any = [];
  public attributeIdList: any = [];
  public attributeListForProduct: any = [];
  @Output() onConfirAttribute: EventEmitter<any> = new EventEmitter<any>();

  checkBoxControl: UntypedFormControl = new UntypedFormControl();
  changeValue(isChecked: boolean, row) {

    if (isChecked) {
      let indexForSelection = this.selectionProduct.findIndex
        (x => x == row.entityId)

      if (indexForSelection < 0) {
        this.selectionProduct.push(row.entityId);
        this.checkBoxControl.patchValue(row.entityId)
      }

    } else {
      let indexForSelectedIncrementId = this.selectionProduct.findIndex(x => x == row.entityId)

      this.selectionProduct.splice(indexForSelectedIncrementId, 1);


    }

    this.onConfirAttribute.emit(this.attributeListForProduct);
  }

  selection = new SelectionModel<any>(true, []);
  attributeList: any = [];
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.attributeList.length;
    return numSelected === numRows;

  }

  checkboxLabel(row?: any): string {

    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }


    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  textAccount: string;

  submit() {
    this.deleteAllProduct();
  }



  submit1() {
    //this.deleteAllProductId(id:any)
    this.dialog.closeAll();
  }


  downloadReport(value) {

    if (value == 'full') {
      this.selectionProduct = [];
    }

    this.downloadDataComplete = "Processing";
    this.productService.downloadProductReportPrimary(this.page, this.size, this.sortParam, this.selectionProduct).subscribe(
      data => {
        this.downloadDataComplete = "OK";
        download(data);
        this.selectionProduct = [];
        this.dialog.closeAll();
      },
    )
  }

  @ViewChild('download') download: TemplateRef<any>;

  openDialog() {
    let dialogRef = this.dialog.open(this.download, {
      width: '350px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }

  firstFormGroup = this._formBuilder.group({
    page: ['', Validators.required],
    size: ['', Validators.required],
    sort: ['', Validators.required],
    sortBy: ['0']

  });

  booleanField: any = [
    { "value": "asc", "viewValue": "ASC" },
    { "value": "desc", "viewValue": "DESC" },
  ]

  downloadData() {

    if (this.firstFormGroup.valid) {
      console.log(this.firstFormGroup);
      this.page = this.firstFormGroup.value.page;
      this.sortParam = this.firstFormGroup.value.sort;
      this.size = this.firstFormGroup.value.size;
      if (this.firstFormGroup.value.sortBy == 'asc') {
        this.sortParam = this.sortParam + "," + Constant.Asc;
      } else if (this.firstFormGroup.value.sortBy == 'desc') {
        this.sortParam = this.sortParam + "," + Constant.Dsc;
      }
      this.downloadReport('full');

    } else {
      this.firstFormGroup.markAllAsTouched();

    }
  }

  restritionPopup() {

    let dialogRef = this.dialog.open(RestrictionComponent, {
      width: '350px',
    });
  }

  exportDataFilter() {
    if (window.innerWidth < 768) {

      let dialogRef = this.dialog.open(CommonDownloadComponent, {
        maxWidth: '100vh',
        height: '100vh',
        width: '100%', disableClose: true,
        data: {
          url: 'getProducts',
          obj: this.filterSelectObjDub,
          columns: this.columns,
          colummnToBeRemoved: ['additionalSpec', 'attributeCode', 'attributeSetId', 'attributeSetName', 'averageRating', 'calculateAvgRating', 'calculateSubtotalOnly', 'categoryId', 'categoryName', 'configProduct', 'configurableProductActive', 'configurableProductDropdown', 'configurableProductMap', 'crossSells', 'enableQtyIncrements', 'entityId', 'featured', 'hideinShop', 'isCustomized', 'isCustomizedValue', 'values', 'categoryNames', 'type', 'discountPercentage', 'emi', 'keyword', 'shortDescription', 'maintainStockIndConfProduct', 'maintainPriceIndConfProduct', 'maintainImageIndConfProduct', 'stockId', 'images', 'websiteId', 'isQtyDecimal', 'notifyStockQty', 'tax', 'taxClassId', 'posHide', 'posPrice', 'posSpecialPrice', 'relatedProducts', 'upSells', 'priceCust', 'supplierId', 'visibility', 'stockStatus'],
          useDefaultHeading: false,
          url2: 'getProducts',
          header: [''],
          service: 'productService',
          headerName: 'Product Download',
          dowloadFileName: 'Product'
        }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] != 'close') {

        }
      });
    }
    else {
      let dialogRef = this.dialog.open(CommonDownloadComponent, {
        height: '400px',
        disableClose: true,
        data: {
          url: 'getProducts',
          obj: this.filterSelectObjDub,
          columns: this.columns,
          colummnToBeRemoved: ['additionalSpec', 'attributeCode', 'attributeSetId', 'attributeSetName', 'averageRating', 'calculateAvgRating', 'calculateSubtotalOnly', 'categoryId', 'categoryName', 'configProduct', 'configurableProductActive', 'configurableProductDropdown', 'configurableProductMap', 'crossSells', 'enableQtyIncrements', 'entityId', 'featured', 'hideinShop', 'isCustomized', 'isCustomizedValue', 'values', 'categoryNames', 'type', 'discountPercentage', 'emi', 'keyword', 'shortDescription', 'maintainStockIndConfProduct', 'maintainPriceIndConfProduct', 'maintainImageIndConfProduct', 'stockId', 'images', 'websiteId', 'isQtyDecimal', 'notifyStockQty', 'tax', 'taxClassId', 'posHide', 'posPrice', 'posSpecialPrice', 'relatedProducts', 'upSells', 'priceCust', 'supplierId', 'visibility', 'stockStatus'],
          useDefaultHeading: false,
          url2: 'getProducts',
          header: [''],
          service: 'productService',
          headerName: 'Product Download',
          dowloadFileName: 'Product'
        }
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] != 'close') {

        }
      });
    }

  }

  importExcelAdvance() {
    this.router.navigate([`/product/xl_Mapper`])
  }

  isAtStart = true;
  isAtEnd = false;
  @ViewChild('stepsWrapper') stepsWrapper!: ElementRef<HTMLDivElement>;

  checkScrollPosition(): void {
    const { scrollLeft, scrollWidth, clientWidth } = this.stepsWrapper.nativeElement;
    this.isAtStart = scrollLeft === 0;
    // Check if we are at the end (with a small tolerance for fractional pixels)
    this.isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
  }

  scroll(direction: 'left' | 'right'): void {
    const element = this.stepsWrapper.nativeElement;

    const scrollAmount = element.clientWidth * 0.8;

    if (direction === 'left') {
      element.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      element.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    setTimeout(() => this.checkScrollPosition(), 500);
  }

  setupSteps: any[] = [
    //  { id: 1, icon: 'auto_awesome', label: 'Personalize your CRM', status: 'active' },
    // { id: 2, icon: 'download', label: 'Import Lead', status: 'pending' },
  ];

  previousValues: { [key: string]: any } = {};

  onStepClick(step: any) {
    if (step.label === 'Personalize your CRM') {
      this.openBusinessEditDialog();
    }
  }

  openBusinessEditDialog(): void {
    if (this.dialog.openDialogs.length > 0) {
      return; // Don't open again
    }
    if (window.innerWidth > 768) {
      const dialogRef = this.dialog.open(CrmBusinessEditComponent, {
        width: '800px',
        panelClass: 'business-edit-dialog',
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result && result['event'] == 'add') {
          window.location.reload();
          console.log("here dialog close");

        }
      });
    } else {

      const dialogRef = this.dialog.open(CrmBusinessEditComponent, {
        minWidth: '100vw', height: '100vh',
        panelClass: '',
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result && result['event'] == 'add') {
          window.location.reload();

        }
      });

    }

  }


  editingCell: { rowId: any; colProperty: string } | null = null;

  editingElement: any = null;
  editingCol: any = null;

  refresh() {

    this.loaderService.show();
    this.onFilterChangeColumn(undefined)
    this.clearValue();

  }

  clearValue() {
    this.editingCell = null;
    this.editingElement = null;
    this.editingCol = null;
    let url = this.router.url;
    let cleanUrl = url.split('?')[0];
    localStorage.removeItem(cleanUrl);
    localStorage.removeItem(cleanUrl + "se"); localStorage.removeItem(cleanUrl + "select");
    localStorage.removeItem(cleanUrl + "type");
    localStorage.removeItem(cleanUrl + "range");
    localStorage.removeItem("advanceFilterConditionsText");
    localStorage.removeItem("advanceFilterEnble");
    localStorage.removeItem("advanceFilterConditions");
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreen();
  }

  isFilterPanelOpen = false;
  isFilterPanelColumnOpen = false;

  toggleFilterPanel(): void {
    if (window.innerWidth <= 768) {
      this.isGridVisible = false;
    }
    this.isFilterPanelOpen = !this.isFilterPanelOpen;
    if (this.isFilterPanelOpen) {
      this.isFilterPanelColumnOpen = false;
    }
    this.checkScreen();
  }
  toggleFilterColumnPanel(): void {
    if (window.innerWidth <= 768) {
      this.isGridVisible = false;
    }
    this.isFilterPanelColumnOpen = !this.isFilterPanelColumnOpen;
    if (this.isFilterPanelColumnOpen) {
      this.isFilterPanelOpen = false;
    }
    this.checkScreen();
  }

  viewMode: 'compact' | 'comfortable' = 'compact';

  setView(mode: 'compact' | 'comfortable') {
    this.viewMode = mode;
  }

  closePopupTwo(event) {
    if (event == true) {
      this.toggleFilterColumnPanel();
    }

  }

  closePopupNew(event) {
    if (event == true) {
      this.toggleFilterPanel();
    }
  }

  isMobile = false;

  checkScreen() {
    this.isMobile = window.innerWidth <= 768;
    if (this.isFilterPanelOpen || this.isFilterPanelColumnOpen) {
      this.rowLeft = "70";
      this.rowRight = "30";
      this.rowgap = "16px";
      if (window.innerWidth <= 768) {
        this.rowRight = "100";
        this.rowLeft = "0";
      }
    } else {
      this.rowLeft = "100";
      this.rowRight = "0";
      this.rowgap = "0px";
      if (window.innerWidth <= 768) {
        this.isGridVisible = true;
      }
    }
  }

  trackByProp = (_: number, col: ListColumn) => col.property;


  isInStock: any = [
    { value: 0, viewValue: 'No' },
    { value: 1, viewValue: 'Yes' },
  ]



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }





}
